module.exports = __webpack_public_path__ + "img/top.23a1158.png";